<template>
	<div> 
	     
       <header-bar></header-bar> 

       <v-content>
          <v-container fluid>
            <router-view></router-view>
          </v-container>
        </v-content>

       

	</div>    
</template>

<script>
 
  import HeaderBar from '../components/header.vue' 
  export default {
    components: { HeaderBar},
    data () {
      return {
         
        title: 'DIA - Institute Information Management System'
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/layouts/formLayout.vue